import { DelegationInterface } from '@/shared/interfaces/delegation.interface';
import { LocationInterface } from '@/shared/interfaces/location.interface';

export enum MainContainerColor {
  White = 'main-container--white',
  GreyCustom = 'main-container--grey-custom',
  GreyLight = 'main-container--grey-light',
}

export interface State {
  openNavbar: boolean;
  scrollTop: number;
  delegationList: DelegationInterface[];
  locationList: LocationInterface[];
  serverError: string;
  clientMainContainerColor: MainContainerColor;
}

export const state: State = {
  openNavbar: true,
  scrollTop: 0,
  delegationList: [],
  locationList: [],
  serverError: '',
  clientMainContainerColor: MainContainerColor.GreyLight,
};
